module.exports = __webpack_public_path__ + "static/img/pd_detail_2.df96215.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footerpic/footerDetailPic/pd_detail_2.jpg
// module id = IzGh
// module chunks = 51